import type { ReactNode } from "react"

export interface OnboardingPhase {
  id: string
  title: string
  label: string
  description: string
  icon: ReactNode
}

export type PhaseState = "done" | "current" | "next" | "later"

export const clampPhase = (current: number, count: number): number => {
  if (Number.isNaN(current)) return 0
  return Math.max(0, Math.min(Math.floor(current), count - 1))
}

export const clampFraction = (fraction: number): number => (Number.isNaN(fraction) ? 0 : Math.max(0, Math.min(fraction, 1)))

export const phaseState = (index: number, current: number): PhaseState => {
  if (index < current) return "done"
  if (index === current) return "current"
  return index === current + 1 ? "next" : "later"
}

export const progressPercent = (current: number, fraction: number, count: number): number => {
  if (count <= 1) return 100
  return Math.min(((clampPhase(current, count) + clampFraction(fraction)) / (count - 1)) * 100, 100)
}
